import React, { useCallback, useContext, useEffect, useState } from "react";
import {
  Button,
  DatePicker,
  Form,
  Input,
  Modal,
  Select,
  Space,
  Table,
  Tooltip,
} from "antd";
import {
  AuditOutlined,
  CalendarOutlined,
  PlusCircleOutlined,
} from "@ant-design/icons";
import axios from "axios";
import { NotificationInfo, UserInfo } from "../../../../context";
import moment from "moment";
import AddReport from "./AddReport";
import FiledReportDetails from "./FiledReportDetails";
// import POOverviewDetails from "./POOverviewDetails";

const ReportFiled = () => {
  const [reportFiledList, setReportFiledList] = useState({
    data: [],
    ready: false,
  });
  const [merchantList, setMerchantList] = useState({
    data: [],
    ready: false,
  });
  const tableLayout = "";
  const scroll = {};
  const { userData } = useContext(UserInfo);
  const [selectedData, setSelectedData] = useState(null);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [openFilterByDate, setOpenFilterByDate] = useState(false);
  const { rerunNotif } = useContext(NotificationInfo);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [selectedMerchant, setSelectedMerchant] = useState("all");
  const [detailsDrawer, setDetailsDrawer] = useState(false);

  const columns = [
    {
      title: "Date Created",
      dataIndex: "created_at",
      render: (date) => (
        <p>{moment(new Date(date), "YYYY-MM-DD").format("MMMM DD, YYYY")}</p>
      ),
    },
    {
      title: "Description",
      dataIndex: "description",
      render: (text, record) => (
        <p
          style={{
            color: "blue",
          }}
        >
          {text}
        </p>
      ),
    },
    {
      title: "Merchant",
      render: (text, record) => (
        <p>{text.reportfilemerchantinfo.business_name}</p>
      ),
    },

    {
      title: "Merchant Complete",
      render: (text, record) => (
        <p
          style={{
            color: parseInt(text.merchant_approved) === 1 ? "green" : "red",
            fontWeight: "bold",
          }}
        >
          {parseInt(text.merchant_approved) === 1 ? "Complete" : "Pending"}
        </p>
      ),
    },
    {
      title: "Commissary Complete",
      render: (text, record) => (
        <p
          style={{
            color: parseInt(text.commissary_approved) === 1 ? "green" : "red",
            fontWeight: "bold",
          }}
        >
          {parseInt(text.commissary_approved) === 1 ? "Complete" : "Pending"}
        </p>
      ),
    },

    {
      title: "",
      dataIndex: "",
      align: "center",
      render: (text) => (
        <p>
          <Tooltip title="Details">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setDetailsDrawer(true);
              }}
              icon={<AuditOutlined />}
            />
          </Tooltip>
        </p>
      ),
    },
  ];

  const tableProps = {
    bordered: false,
    // loading,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const getReportFiledList = useCallback(() => {
    var params = { user_id: userData.data.id };
    axios
      .get("user/commissary/get/report-filed", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setReportFiledList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  const getMerchantList = useCallback(() => {
    var params = { user_id: userData.data.id };
    axios
      .get("user/commissary/merchant-list", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setMerchantList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  useEffect(() => {
    getReportFiledList();
    getMerchantList();
  }, [getReportFiledList, getMerchantList]);

  const searchable = reportFiledList.data.filter((data) => {
    return (
      data.reportfilemerchantinfo.business_name
        .toLowerCase()
        .indexOf(search.toLowerCase()) >= 0
    );
  });

  const handleFilter = (values) => {
    var params = {
      date_from: moment(new Date(values.date_from), "YYYY-MM-DD").format(
        "YYYY-MM-DD"
      ),
      date_to: moment(new Date(values.date_to), "YYYY-MM-DD").format(
        "YYYY-MM-DD"
      ),
      user_id: userData.data.id,
      merchant_id: selectedMerchant,
    };
    setLoading(true);
    axios
      .get("user/commissary/filter/get/report-filed", { params })
      .then((response) => {
        const data = response.data;
        rerunNotif("success", "Filter successful.");
        setTimeout(() => {
          setOpenFilterByDate(false);
          setLoading(false);
          setReportFiledList({ data, ready: true });
        }, 1000);
      })
      .catch((error) => {
        console.log("Error: ", error);
        // setLoadings(false);
      });
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: 5,
        }}
      >
        <div style={{ flexGrow: 1 }}>
          <Input
            placeholder="Search merchant"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{
              border: "2px solid #e5e5e5",
              width: window.innerWidth < 576 ? "100%" : 300,
            }}
            size="large"
          />
        </div>
        <Tooltip title="Filter by date">
          <Button
            icon={<CalendarOutlined />}
            style={{ marginLeft: 5 }}
            onClick={() => setOpenFilterByDate(true)}
          >
            Filter
          </Button>
        </Tooltip>

        <Tooltip title="File a report">
          <Button
            icon={<PlusCircleOutlined />}
            style={{ marginLeft: 5 }}
            onClick={() => setOpenDrawer(true)}
          >
            Report
          </Button>
        </Tooltip>
      </div>

      <div style={{ overflowX: "auto" }}>
        <Table
          {...tableProps}
          pagination={{
            position: ["bottomCenter"],
          }}
          columns={tableColumns}
          dataSource={searchable.length > 0 ? searchable : []}
          scroll={scroll}
          rowKey={(record) => record.id}
        />
      </div>

      {openDrawer && (
        <AddReport
          open={openDrawer}
          close={() => setOpenDrawer(false)}
          getReportFiledList={() => getReportFiledList()}
          merchantList={merchantList}
        />
      )}

      {detailsDrawer && (
        <FiledReportDetails
          open={detailsDrawer}
          close={() => setDetailsDrawer(false)}
          getReportFiledList={() => getReportFiledList()}
          selectedData={selectedData}
        />
      )}

      <Modal
        title=""
        open={openFilterByDate}
        onCancel={() => setOpenFilterByDate(false)}
        footer={null}
        width={350}
      >
        <Form
          layout="vertical"
          name="basic"
          initialValues={{
            user_id: selectedMerchant,
          }}
          onFinish={handleFilter}
          autoComplete="off"
        >
          <Space
            direction="vertical"
            style={{ width: "100%", margin: 0, marginTop: 20 }}
          >
            <Form.Item
              name="date_from"
              label="Date From"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <DatePicker
                format={"MM/DD/YYYY"}
                size="large"
                style={{ width: "100%" }}
              />
            </Form.Item>

            <Form.Item
              name="date_to"
              label="Date To"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <DatePicker
                format={"MM/DD/YYYY"}
                size="large"
                style={{ width: "100%" }}
              />
            </Form.Item>

            <Form.Item
              name="user_id"
              label="Merchant"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <Select
                placeholder="-"
                onChange={(e) => setSelectedMerchant(e)}
                size="large"
                showSearch
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                <Select.Option value={"all"}>All</Select.Option>
                {merchantList.ready &&
                  merchantList.data.length > 0 &&
                  merchantList.data.map((data, index) => (
                    <Select.Option value={data.user_id} key={index}>
                      {data.business_name}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
          </Space>

          <Form.Item style={{ marginTop: "20px" }}>
            <Button
              type="primary"
              loading={loading}
              htmlType="submit"
              style={{ width: "100%", borderRadius: "20px" }}
            >
              {loading ? "Loading" : "Filter"}
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default ReportFiled;
